// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1EclA","info":"Note_info__1QzEO","note":"Note_note__2zZue","actions":"Note_actions__2C2Bd"};